import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
/* import { AuthProvider } from './AuthContext'; */
import Home from './components/Home';
import About from './components/About';
import AllBooks from './components/AllBooks';
import Contact from './components/Contact';
import RecommendedBooks from './components/RecommendedBooks';
import BooksByLanguage from './components/BooksByLanguage';
import PopularBooks from './components/PopularBooks';
import GenreRecommended from './components/GenreRecommended';
import NewlyAddedBooks from './components/NewlyAddedBooks';
import BooksByAgeGroup from './components/BooksByAgeGroup';
import ScrollToTop from './components/ScrollToTop';
import PDFViewer from './components/PDFViewer';
import EPUBViewer from './components/EPUBViewer';
import BookByGenre from './components/BookByGenre';
import BooksByAgeGroup8to11 from './components/BooksByAgeGroup8to11';
import BookByLanguageCatWise from './components/BookByLanguageCatWise';
import NewEpub from './components/NewEpub';
import Privacy from './components/Privacy';
import TermCondition from './components/TermCondition';
import ScrollToSection from './components/ScrollToSection';
import Nutrition from './components/Nutrition';
import NewHeader from './components/NewHeader';
import Footer from './components/Footer';
import PDFLoader from './components/PDFLoader';
import Gallery from './components/Gallery';
/* import FullBlogs from './components/FullBlogs';
import Media from './components/Media';
import Events from './components/Events'; */
import Login from './components/Login';
import HomeProduction from './components/HomeProduction';

function App() {


  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
      }
    };


    document.addEventListener('keydown', handleKeyDown);


    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.fnKey && e.key === 'F9') {
        e.preventDefault();
      }
    };


    document.addEventListener('keydown', handleKeyDown);


    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


 



  






  return (
    <Router>

      <ScrollToTop />
      <NewHeader />
      {/* <Header /> */}
      <ScrollToSection />
      <Routes>

        <Route path="/language-books" element={
          <BookByLanguageCatWise />
        } />

        <Route path="/genre-books" element={
          <BookByGenre />
        } />
        <Route path="/age-group-books" element={
          <BooksByAgeGroup8to11 />
        } />
        <Route path="/epub" element={
          <EPUBViewer />
        } />
        <Route path="/pdf" element={
          <PDFViewer />

        } />
        {/*  <Route path="/main_blog" element={<FullBlogs />} />
        <Route path="/media" element={<Media />} />
        <Route path="/events" element={<Events />} /> */}
        <Route path="/epubnew" element={<NewEpub />} />
        <Route path="/pdf_loader" element={<PDFLoader />} />
        <Route path="/search/:query" element={<AllBooks />} />
        <Route path="/about" element={
          <About />
        } />

        <Route path="/gallery" element={<Gallery />} />

        <Route path="/contact" element={
          <Contact />
        } />

        <Route path="/home" element={
          <Home />
        } />

        <Route path="/home_live" element={
          <HomeProduction />
        } />
        <Route path="/" element={<Navigate to="/home" />} />

        <Route path="/login" element={<Login />} />

        <Route path="/recommended_books" element={
          <RecommendedBooks />
        } />

        <Route path="/nutrition_books" element={
          <Nutrition />
        } />

        <Route path="/books_by_language" element={<BooksByLanguage />} />
        <Route path="/popular_books" element={
          <PopularBooks />
        } />
        <Route path="/genre_recommended" element={
          <GenreRecommended />
        } />
        <Route path="/newly_added_books" element={
          <NewlyAddedBooks />
        } />
        <Route path="/books_by_age_group" element={
          <BooksByAgeGroup />
        } />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/term_condition" element={<TermCondition />} />
      </Routes>

      <Footer />

    </Router>
  );
}



export default App;
